import { useState } from 'react';
import { Text } from '@shared/components/Text';
import { MBHover } from '@shared/components/hover';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export interface MBSeenByCountTextProps {
  /*
        Number of users
    */
  count: number;
  /*
        Text color. Default is normal gray.
    */
  color?: string;
}

export interface MBSeenWithoutCountTextProps {
  color?: string;
}

function MBSeenHoverLink({ content, color }: { content: string; color: string }) {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <MBHover
      hoverStyle={{ textDecoration: 'underline', color: Colors.v2.gray30 } as any}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <Text size="caption2" color={isHovered ? Colors.v2.gray60 : color}>
        {content}
      </Text>
    </MBHover>
  );
}

export function MBSeenByCountText({ count, color = Colors.v2.gray30 }: MBSeenByCountTextProps) {
  return <MBSeenHoverLink content={i18n('chat.seenBy', { count })} color={color} />;
}

export function MBSeenWithoutCountText({ color = Colors.v2.gray30 }: MBSeenWithoutCountTextProps) {
  return <MBSeenHoverLink content={i18n('chat.seen')} color={color} />;
}
